import { mapMutations, mapState } from 'vuex'
const commonMixin = {
  computed: {
    ...mapState({
      visitedViews: state => state.tagsView.visitedViews,
      visitedMap: state => state.app.visitedMap
    })
  },
  methods: {
    ...mapMutations({
      delMyself: 'DEL_VISITED_VIEWS'
    }),
    goBack(path) {
      // this.distoryTagView(path)
      if (process.env.PROJECT === 'dealer_pc') {
        this.$router.go(-1);
      } else {
        this.distoryTagView(path)
      }
    },
    getFromRoute(key) {
      return this.visitedMap[key]
    },
    distoryTagView(path) {
      const activeItem = this.isActive(this.$route)
      this.$store.dispatch('delVisitedViews', activeItem)
      const latestView = this.visitedViews.slice(-1)[0]
      if (path){
        this.$router.push({'path':path})
      }else {
        const routerFrom = this.getFromRoute(this.$route.path)
        if (routerFrom) {
          this.$router.push({'path':routerFrom.path, 'query':routerFrom.query})
        } else {
          this.$router.push('/')
        }
      }
    },
    isActive(route) {
      let activeItem
      this.visitedViews.forEach((item, index) => {
        if (item.path === this.$route.fullPath) {
          activeItem = item
        }
      })
      return activeItem
    }
  }
}
export default commonMixin



// WEBPACK FOOTER //
// ./src/mixins/common.js